<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div class="h-auto">
      <h4 class="mt-0">
        {{ $getVisibleNames("mesh.career", true, "Programas") }}
        <AlternativeNameButton
          :table_name="'mesh.career'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h4>
      <div class="career-filters noprint mx-3 mb-3">
        <div class="career-filter">
          <label for="career-type-filter" class="career-filter-label">
            {{
              $t("careerOrPrograms.careerListView.typeFilterLabel", {
                entity: $getVisibleNames("mesh.career", false, "Programa"),
              })
            }}
          </label>
          <b-form-select
            id="career-type-filter"
            class="career-filter-input"
            v-model="profile_type_id"
          >
            <option :value="null">
              {{ $t("careerOrPrograms.careerListView.allOptions") }}
            </option>
            <option
              v-for="type in profileTypes"
              :key="type.id"
              :value="type.id"
            >
              {{ type.name }}
            </option>
          </b-form-select>
        </div>
        <div class="career-filter career-filter-wide">
          <label for="career-faculty-filter" class="career-filter-label">
            {{ $getVisibleNames("mesh.faculty", true, "Facultades") }}
          </label>
          <v-select
            input-id="career-faculty-filter"
            class="career-filter-multiselect"
            v-model="faculty_ids"
            :options="faculties"
            :reduce="(faculty) => faculty.id"
            label="name"
            multiple
            :close-on-select="false"
            :placeholder="$t('careerOrPrograms.careerListView.allOptions')"
          ></v-select>
        </div>
        <b-button
          v-if="has_active_filters"
          variant="link"
          size="sm"
          class="career-filters-clear"
          @click="clearFilters"
        >
          <b-icon icon="x-circle"></b-icon>
          {{ $t("careerOrPrograms.careerListView.clearFilters") }}
        </b-button>
      </div>
      <div>
        <template>
          <div class="d-flex justify-content-between mx-3 noprint">
            <div>
              <ButtonMedium
                v-can="'mesh.add_career'"
                v-if="
                  allows_crud &&
                  !user.group_names.includes(
                    'ADMINISTRATIVOS INSTRUCCIONALES'
                  ) &&
                  ([
                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                  ].some((group) => user.group_names.includes(group)) ||
                    user.is_superuser ||
                    $hasObjectPermission('mesh.faculty', 'add') ||
                    $hasObjectPermission('mesh.egressprofile', 'add'))
                "
                :tooltip_text="
                  $t('reusable.common.addTooltip', {
                    entity: $getVisibleNames(
                      'manual.programa',
                      false,
                      'Programa'
                    ),
                  })
                "
                :text_button="$t('reusable.common.add')"
                v-b-modal.new-career-modal
                :icon="'plus'"
                :variant="'primary'"
              >
              </ButtonMedium>
              <!-- $hasObjectPermission('mesh.career', 'add') || -->
            </div>
            <div class="d-flex">
              <div
                v-if="
                  user &&
                  (user.group_names.includes(
                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                  ) ||
                    user.is_superuser)
                "
              >
                <b-button
                  class="ml-3 noprint"
                  size="sm"
                  @click="redirectToCareerReport()"
                  ><b-icon icon="box-arrow-up-right"></b-icon>
                  {{
                    $t("careerOrPrograms.careerListView.report", {
                      entity: $getVisibleNames(
                        "mesh.career",
                        true,
                        "Programas"
                      ),
                    })
                  }}
                </b-button>
              </div>
              <div
                v-b-tooltip.topleft.v-danger.noninteractive="
                  `${
                    selected_egress_profiles.length == 0 &&
                    !user.is_superuser &&
                    !user.group_names.includes(
                      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                    )
                      ? $t(
                          'careerOrPrograms.careerListView.needToChooseAtLeastOne',
                          {
                            entity: $getVisibleNames(
                              'mesh.egressprofile',
                              false,
                              'Perfil de Egreso'
                            ),
                          }
                        )
                      : ''
                  }${
                    selected_egress_profiles.length >
                      max_egress_profiles_selection &&
                    !user.is_superuser &&
                    !user.group_names.includes(
                      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                    )
                      ? $t(
                          'careerOrPrograms.careerListView.cannotChooseMoreThan',
                          {
                            entity: max_egress_profiles_selection,
                            entity2: $getVisibleNames(
                              'mesh.egressprofile',
                              true,
                              'Perfiles de Egreso'
                            ),
                          }
                        )
                      : ''
                  }`
                "
              >
                <ContainerButtonsDownload
                  v-if="
                    institution &&
                    (institution.internal_use_id == 'duoc.cl' ||
                      institution.internal_use_id == 'iacc.cl') &&
                    ([
                      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                      'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                      'DIRECTIVOS FACULTAD O ESCUELA',
                      'DIRECTORES DE CARRERA',
                      'DIRECTORES DE CARRERA (CAMPUS)',
                      'ADMINISTRATIVOS INSTRUCCIONALES',
                    ].some((group) => user.group_names.includes(group)) ||
                      user.is_superuser)
                  "
                  :id_button="`ContainerButtonsDownload`"
                  :text_button="`${
                    selected_egress_profiles.length > 0
                      ? '(' + selected_egress_profiles.length + ') '
                      : ''
                  }${$t('careerOrPrograms.careerListView.download')}`"
                  :disabled_button="
                    (selected_egress_profiles.length == 0 &&
                      !user.is_superuser &&
                      !user.group_names.includes(
                        'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                      )) ||
                    (selected_egress_profiles.length >
                      max_egress_profiles_selection &&
                      !user.is_superuser &&
                      !user.group_names.includes(
                        'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                      ))
                  "
                  class="ml-2"
                >
                  <template #popover-container-buttons>
                    <div
                      v-if="
                        institution &&
                        institution.internal_use_id == 'duoc.cl' &&
                        ([
                          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                          'DIRECTIVOS FACULTAD O ESCUELA',
                          'DIRECTORES DE CARRERA',
                          'DIRECTORES DE CARRERA (CAMPUS)',
                          'ADMINISTRATIVOS INSTRUCCIONALES',
                        ].some((group) => user.group_names.includes(group)) ||
                          user.is_superuser)
                      "
                      v-b-tooltip.topleft.v-danger.noninteractive="
                        `${
                          selected_egress_profiles.length == 0 &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.needToChooseAtLeastOne',
                                {
                                  entity: $getVisibleNames(
                                    'mesh.egressprofile',
                                    false,
                                    'Perfil de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }${
                          selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.cannotChooseMoreThan',
                                {
                                  entity: max_egress_profiles_selection,
                                  entity2: $getVisibleNames(
                                    'mesh.egressprofile',
                                    true,
                                    'Perfiles de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }`
                      "
                    >
                      <!-- :text_button="`${
                        selected_egress_profiles.length > 0
                          ? selected_egress_profiles.length +
                            ' - Reporte Planes y Asignaturas'
                          : 'Reporte Planes y Asignaturas'
                      }`" -->
                      <!-- :tooltip_text="`Reporte Planes y Asignaturas`" -->
                      <GenericButtonDownload
                        :text_button="
                          $t(
                            'careerOrPrograms.careerListView.plansAndSubjectsReport'
                          )
                        "
                        :variant_button="`success`"
                        :click_button="DownloadExcel"
                        :disabled_button="
                          disabled_button_excel ||
                          (selected_egress_profiles.length == 0 &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            )) ||
                          (selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            ))
                        "
                        :icon_excel="true"
                        :class="`w-100 text-left`"
                      ></GenericButtonDownload>
                    </div>
                    <div
                      v-if="
                        institution &&
                        institution.internal_use_id == 'duoc.cl' &&
                        ([
                          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                          'DIRECTIVOS FACULTAD O ESCUELA',
                          'DIRECTORES DE CARRERA',
                          'DIRECTORES DE CARRERA (CAMPUS)',
                          'ADMINISTRATIVOS INSTRUCCIONALES',
                        ].some((group) => user.group_names.includes(group)) ||
                          user.is_superuser)
                      "
                      v-b-tooltip.topleft.v-danger.noninteractive="
                        `${
                          selected_egress_profiles.length == 0 &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.needToChooseAtLeastOne',
                                {
                                  entity: $getVisibleNames(
                                    'mesh.egressprofile',
                                    false,
                                    'Perfil de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }${
                          selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.cannotChooseMoreThan',
                                {
                                  entity: max_egress_profiles_selection,
                                  entity2: $getVisibleNames(
                                    'mesh.egressprofile',
                                    true,
                                    'Perfiles de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }`
                      "
                    >
                      <!-- :tooltip_text="`Reporte Planes y evaluaciones`" -->
                      <GenericButtonDownload
                        :text_button="
                          $t(
                            'careerOrPrograms.careerListView.plansAndEvaluationsReport'
                          )
                        "
                        :variant_button="`success`"
                        :click_button="DownloadExcelEvaluation"
                        :disabled_button="
                          disabled_button_excel ||
                          (selected_egress_profiles.length == 0 &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            )) ||
                          (selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            ))
                        "
                        :icon_excel="true"
                        :class="`w-100 text-left`"
                      ></GenericButtonDownload>
                    </div>
                    <div
                      v-if="
                        institution &&
                        institution.internal_use_id == 'duoc.cl' &&
                        ([
                          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                          'DIRECTIVOS FACULTAD O ESCUELA',
                          'DIRECTORES DE CARRERA',
                          'DIRECTORES DE CARRERA (CAMPUS)',
                          'ADMINISTRATIVOS INSTRUCCIONALES',
                        ].some((group) => user.group_names.includes(group)) ||
                          user.is_superuser)
                      "
                      v-b-tooltip.topleft.v-danger.noninteractive="
                        `${
                          selected_egress_profiles.length == 0 &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.needToChooseAtLeastOne',
                                {
                                  entity: $getVisibleNames(
                                    'mesh.egressprofile',
                                    false,
                                    'Perfil de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }${
                          selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.cannotChooseMoreThan',
                                {
                                  entity: max_egress_profiles_selection,
                                  entity2: $getVisibleNames(
                                    'mesh.egressprofile',
                                    true,
                                    'Perfiles de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }`
                      "
                    >
                      <!-- :tooltip_text="`Reporte Tecnología Educativa`" -->
                      <GenericButtonDownload
                        :text_button="
                          $t(
                            'careerOrPrograms.careerListView.educationalTechnologyReport'
                          )
                        "
                        :variant_button="`success`"
                        :click_button="DownloadExcelTecnology"
                        :disabled_button="
                          disabled_button_excel ||
                          (selected_egress_profiles.length == 0 &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            )) ||
                          (selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            ))
                        "
                        :icon_excel="true"
                        :class="`w-100 text-left`"
                      ></GenericButtonDownload>
                    </div>
                    <div
                      v-if="
                        institution &&
                        institution.internal_use_id == 'duoc.cl' &&
                        ([
                          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                          'DIRECTIVOS FACULTAD O ESCUELA',
                          'DIRECTORES DE CARRERA',
                          'DIRECTORES DE CARRERA (CAMPUS)',
                          'ADMINISTRATIVOS INSTRUCCIONALES',
                        ].some((group) => user.group_names.includes(group)) ||
                          user.is_superuser)
                      "
                      v-b-tooltip.topleft.v-danger.noninteractive="
                        `${
                          selected_egress_profiles.length == 0 &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.needToChooseAtLeastOne',
                                {
                                  entity: $getVisibleNames(
                                    'mesh.egressprofile',
                                    false,
                                    'Perfil de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }${
                          selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.cannotChooseMoreThan',
                                {
                                  entity: max_egress_profiles_selection,
                                  entity2: $getVisibleNames(
                                    'mesh.egressprofile',
                                    true,
                                    'Perfiles de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }`
                      "
                    >
                      <GenericButtonDownload
                        :text_button="
                          $t(
                            'careerOrPrograms.careerListView.mandatoryBibliographyReport'
                          )
                        "
                        :variant_button="`success`"
                        :click_button="DownloadExcelMandatoryBibliography"
                        :disabled_button="
                          disabled_button_excel ||
                          (selected_egress_profiles.length == 0 &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            )) ||
                          (selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            ))
                        "
                        :icon_excel="true"
                        :class="`w-100 text-left`"
                      ></GenericButtonDownload>
                    </div>
                    <div
                      v-if="
                        institution &&
                        (institution.internal_use_id == 'duoc.cl' ||
                          institution.internal_use_id == 'iacc.cl') &&
                        ([
                          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                          'DIRECTIVOS FACULTAD O ESCUELA',
                          'DIRECTORES DE CARRERA',
                          'DIRECTORES DE CARRERA (CAMPUS)',
                          'ADMINISTRATIVOS INSTRUCCIONALES',
                        ].some((group) => user.group_names.includes(group)) ||
                          user.is_superuser)
                      "
                      v-b-tooltip.topleft.v-danger.noninteractive="
                        `${
                          selected_egress_profiles.length == 0 &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.needToChooseAtLeastOne',
                                {
                                  entity: $getVisibleNames(
                                    'mesh.egressprofile',
                                    false,
                                    'Perfil de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }${
                          selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                          !user.is_superuser &&
                          !user.group_names.includes(
                            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                          )
                            ? $t(
                                'careerOrPrograms.careerListView.cannotChooseMoreThan',
                                {
                                  entity: max_egress_profiles_selection,
                                  entity2: $getVisibleNames(
                                    'mesh.egressprofile',
                                    true,
                                    'Perfiles de Egreso'
                                  ),
                                }
                              )
                            : ''
                        }`
                      "
                    >
                      <GenericButtonDownload
                        :text_button="
                          $t(
                            institution &&
                              institution.internal_use_id == 'duoc.cl'
                              ? 'careerOrPrograms.careerListView.valuationReport'
                              : 'careerOrPrograms.careerListView.mattersReport',
                            {
                              entity: $getVisibleNames(
                                'mesh.egressprofilematter',
                                true,
                                'Asignaturas'
                              ),
                            }
                          )
                        "
                        :variant_button="`success`"
                        :click_button="DownloadValuationReportExcel"
                        :disabled_button="
                          disabled_button_excel ||
                          (selected_egress_profiles.length == 0 &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            )) ||
                          (selected_egress_profiles.length >
                            max_egress_profiles_selection &&
                            !user.is_superuser &&
                            !user.group_names.includes(
                              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                            ))
                        "
                        :icon_excel="true"
                        :class="`w-100 text-left`"
                      ></GenericButtonDownload>
                    </div>
                  </template>
                </ContainerButtonsDownload>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="mt-2">
        <div
          v-if="
            institution &&
            (institution.internal_use_id == 'duoc.cl' ||
              institution.internal_use_id == 'iacc.cl') &&
            selected_egress_profiles.length > 0 &&
            total_careers > 0
          "
          class="bulk-selection-banner noprint"
        >
          <template v-if="!all_items_fetched">
            <span>{{
              $t("careerOrPrograms.careerListView.profilesSelected", {
                count: selected_egress_profiles.length,
              })
            }}</span>
            <b-button
              variant="link"
              size="sm"
              class="p-0 ml-2"
              @click="selectAllItems"
            >
              {{
                $t("careerOrPrograms.careerListView.selectAllPrograms", {
                  count: total_careers,
                })
              }}
            </b-button>
          </template>
          <template v-else>
            <span>{{
              $t("careerOrPrograms.careerListView.allSelected", {
                count: selected_egress_profiles.length,
              })
            }}</span>
            <b-button
              variant="link"
              size="sm"
              class="p-0 ml-2"
              @click="clearSelection"
            >
              {{ $t("careerOrPrograms.careerListView.clearSelection") }}
            </b-button>
          </template>
        </div>
        <CareerTable
          :key="table_refresh_key"
          :allows_crud="allows_crud"
          :profile_type_id="profile_type_id"
          :faculty_ids="faculty_ids"
          :selected_egress_profiles="selected_egress_profiles"
          :fully_visible_professor_egress_profiles="
            fully_visible_professor_egress_profiles
          "
          :fields="fields"
          :fieldsEgressProfile="fieldsEgressProfile"
          @change-selected-career="changeSelectedCareer"
          @change-selected-egress-profile="changeSelectedEgressProfile"
          @toggle-select-all-page="toggleSelectAllPage"
          @total-items="onTotalItems"
          @create-egress-profile="slotCreateEgressProfile"
          @ask-delete="askForDeleteCareer"
          @career-updated="table_refresh_key++"
        ></CareerTable>
      </div>
    </div>
    <div>
      <b-modal
        id="new-career-modal"
        :title="
          $t('reusable.common.createModalTitle', {
            entity: $getVisibleNames('mesh.career', false, 'Programa'),
          })
        "
        size="lg"
        hide-footer
      >
        <CareerForm
          @created="slotCreatedCareer"
          :show_title="false"
        ></CareerForm>
      </b-modal>
    </div>
    <b-modal
      id="modal-create-egress-profile"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      size="lg"
      hide-footer
    >
      <EgressProfileForm
        v-if="institution"
        :default_max_semester_amount="institution.max_semester_amount"
        :career_id="career_id_for_egress_modal"
        @created="slotCreatedEgreesProfile"
      ></EgressProfileForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapGetters } from "vuex";
import {
  toast,
  showLoadingAlert,
  downloadFileFromResponse,
} from "@/utils/utils";

export default {
  name: "CareerListView",
  components: {
    vSelect,
    CareerForm: () => import("./Career/CareerForm"),
    CareerTable: () => import("./CareerTable"),
    EgressProfileForm: () =>
      import("@/components/mesh/EgressProfile/EgressProfileForm"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    ContainerButtonsDownload: () =>
      import("@/components/reusable/Buttons/ContainerButtonsDownload"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      is_hidden: true,
      isDropdown2Visible: false,
      profile_type_id: null,
      faculty_ids: [],
      career_id_for_egress_modal: null,
      table_refresh_key: 0,
      selected_tab: 8,
      checked: false,
      fully_visible_professor_egress_profiles: [],
      selected_egress_profiles: [],
      disabled_button_excel: false,
      max_egress_profiles_selection: 30,
      total_careers: 0,
      all_items_fetched: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      profileTypes: names.PROFILE_TYPES,
      faculties: names.FACULTIES,
      modalities_egress_profiles: names.MODALITIES_EGRESS_PROFILE,
    }),
    has_active_filters() {
      return this.profile_type_id != null || this.faculty_ids.length > 0;
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_career");
      if (has_permission) return has_permission;
      else return false;
    },
    breadcrumb_items() {
      let breadcrumb = [
        {
          text: this.$t("reusable.breadcrumb.home"),
          to: "/home",
        },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
        },
      ];
      return breadcrumb;
    },
    fields() {
      let fields = [];
      if (
        this.institution &&
        (this.institution.internal_use_id == "duoc.cl" ||
          this.institution.internal_use_id == "iacc.cl")
      )
        fields = fields.concat([
          {
            key: "selected",
            label: "",
            display_column: true,
            thStyle: {
              position: "sticky !important",
            },
          },
        ]);
      fields = fields.concat([
        {
          key: "faculty",
          label: String(
            this.$getVisibleNames("mesh.faculty", true, "Facultades")
          ),
          sortable: true,
          // La celda muestra el nombre de la facultad, no su id
          ordering_key: "faculty__name",
          display_column: true,
          thStyle: {
            position: "sticky !important",
          },
        },
        {
          key: "egress_profile_year",
          label: this.$t("careerOrPrograms.careerListView.year"),
          sortable: false,
          display_column: true,
          thStyle: {
            position: "sticky !important",
          },
        },
        {
          key: "name",
          label: String(
            this.$getVisibleNames("mesh.career", true, "Programas")
          ),
          sortable: true,
          display_column: true,
          thStyle: {
            position: "sticky !important",
          },
        },
        {
          key: "egress_profile_curricular_number",
          label: this.$t("careerOrPrograms.careerListView.curriculumNumber"),
          sortable: false,
          display_column: true,
          thStyle: {
            position: "sticky !important",
          },
        },
        {
          key: "egress_profile_modality",
          label: this.$t("careerOrPrograms.careerListView.modality"),
          sortable: false,
          display_column: true,
          thStyle: {
            position: "sticky !important",
          },
        },
        {
          key: "type",
          label: String(this.$t("careerOrPrograms.careerListView.programType")),
          sortable: true,
          // La celda muestra el nombre del tipo de perfil de egreso
          ordering_key: "egress_profile_type__name",
          display_column: true,
          thStyle: {
            position: "sticky !important",
          },
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "text-right noprint",
          tdClass: "text-right noprint",
          thStyle: {
            position: "sticky !important",
          },
        },
      ]);
      return fields;
    },
    fieldsEgressProfile() {
      let fields = [];
      if (
        this.institution &&
        (this.institution.internal_use_id == "duoc.cl" ||
          this.institution.internal_use_id == "iacc.cl")
      )
        fields = fields.concat([
          {
            key: "selected",
            label: "",
            display_column: true,
            thStyle: {
              color: "white",
            },
          },
        ]);

      fields = fields.concat([
        {
          key: "professional_title",
          label:
            this.institution && this.institution.internal_use_id == "iacc.cl"
              ? this.$getVisibleNames(
                  "manual.mesh.titulo_profesional",
                  false,
                  "Título Profesional"
                )
              : this.$getVisibleNames("mesh.egressprofile", true, "Programas"),
          sortable: false,
          display_column: true,
          tdClass: "text-left",
          thStyle: {
            color: "white",
          },
        },
        {
          key: "init_date",
          label: this.$t("careerOrPrograms.careerListView.year"),
          sortable: false,
          display_column: true,
          formatter: (value) => {
            if (value != null) return parseInt(String(value).substr(0, 4));
            else return "";
          },
          thStyle: {
            color: "white",
          },
        },
        {
          key: "code",
          label: this.$t("careerOrPrograms.careerListView.curriculumNumber"),
          sortable: false,
          display_column: true,
          tdClass: "text-left",
          thStyle: {
            color: "white",
          },
        },
        {
          key: "modality",
          label: this.$t("careerOrPrograms.careerListView.modality"),
          sortable: false,
          display_column: true,
          formatter: (value) => {
            return this.getModalityName(value);
          },
          thStyle: {
            color: "white",
          },
        },
        {
          key: "actions",
          label: "",
          sortable: false,
          display_column: true,
          tdClass: "text-right",
          thStyle: {
            color: "white",
          },
        },
      ]);
      return fields;
    },
  },
  methods: {
    DownloadExcel() {
      if (
        this.selected_egress_profiles.length > 0 ||
        (this.selected_egress_profiles.length == 0 &&
          this.user &&
          (this.user.is_superuser ||
            this.user.group_names.includes(
              "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
            )))
      ) {
        this.disabled_button_excel = true;
        // Alerta de "Generando Excel..."
        showLoadingAlert(
          this.$t("reusable.common.generatingExcel"),
          this.$t("reusable.common.pleaseWaitFile")
        );
        this.$restful
          .Post(
            `/mesh/excel_report_duoc_academic_record/`,
            {
              egress_profiles: this.selected_egress_profiles,
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            this.$swal.close();
            // Usar la función utilitaria para descargar el blob
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                // onSuccess callback
                this.disabled_button_excel = false;
              },
              () => {
                // onError callback
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          })
          .catch(() => {
            this.disabled_button_excel = false;
            this.$swal.close();
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.problemGenerating"),
              "error"
            );
          });
      }
    },
    DownloadExcelEvaluation() {
      if (
        this.selected_egress_profiles.length > 0 ||
        (this.selected_egress_profiles.length == 0 &&
          this.user &&
          (this.user.is_superuser ||
            this.user.group_names.includes(
              "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
            )))
      ) {
        this.disabled_button_excel = true;
        // Alerta de "Generando Excel..."
        showLoadingAlert(
          this.$t("reusable.common.generatingExcel"),
          this.$t("reusable.common.pleaseWaitFile")
        );
        this.$restful
          .Post(
            `/evaluations2/egress_profiles_and_evaluations/`,
            {
              egress_profiles: this.selected_egress_profiles,
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            this.$swal.close();
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          })
          .catch(() => {
            this.disabled_button_excel = false;
            this.$swal.close();
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.problemGenerating"),
              "error"
            );
          });
      }
    },
    DownloadExcelTecnology() {
      if (
        this.selected_egress_profiles.length > 0 ||
        (this.selected_egress_profiles.length == 0 &&
          this.user &&
          (this.user.is_superuser ||
            this.user.group_names.includes(
              "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
            )))
      ) {
        this.disabled_button_excel = true;
        // Alerta de "Generando Excel..."
        showLoadingAlert(
          this.$t("reusable.common.generatingExcel"),
          this.$t("reusable.common.pleaseWaitFile")
        );
        this.$restful
          .Post(
            `/mesh/egress_profiles_and_teaching_support_resources/`,
            {
              egress_profiles: this.selected_egress_profiles,
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            this.$swal.close();
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          })
          .catch(() => {
            this.disabled_button_excel = false;
            this.$swal.close();
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.problemGenerating"),
              "error"
            );
          });
      }
    },
    DownloadExcelMandatoryBibliography() {
      if (
        this.selected_egress_profiles.length > 0 ||
        (this.selected_egress_profiles.length == 0 &&
          this.user &&
          (this.user.is_superuser ||
            this.user.group_names.includes(
              "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
            )))
      ) {
        this.disabled_button_excel = true;
        // Alerta de "Generando Excel..."
        showLoadingAlert(
          this.$t("reusable.common.generatingExcel"),
          this.$t("reusable.common.pleaseWaitFile")
        );
        this.$restful
          .Post(
            `/mesh/egress_profiles_and_mandatory_bibliography/`,
            {
              egress_profiles: this.selected_egress_profiles,
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            this.$swal.close();
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          })
          .catch(() => {
            this.disabled_button_excel = false;
            this.$swal.close();
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.problemGenerating"),
              "error"
            );
          });
      }
    },
    DownloadValuationReportExcel() {
      if (
        this.selected_egress_profiles.length > 0 ||
        (this.selected_egress_profiles.length == 0 &&
          this.user &&
          (this.user.is_superuser ||
            this.user.group_names.includes(
              "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
            )))
      ) {
        this.disabled_button_excel = true;
        // Alerta de "Generando Excel..."
        showLoadingAlert(
          this.$t("reusable.common.generatingExcel"),
          this.$t("reusable.common.pleaseWaitFile")
        );
        this.$restful
          .Post(
            `/teaching/excel_egress_profile_matters_report/`,
            {
              egress_profile_ids: this.selected_egress_profiles,
            },
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            this.$swal.close();
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          })
          .catch(() => {
            this.disabled_button_excel = false;
            this.$swal.close();
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.problemGenerating"),
              "error"
            );
          });
      }
    },
    changeSelectedCareer(egress_profiles_ids) {
      this.all_items_fetched = false;
      if (
        egress_profiles_ids.every((id) =>
          this.selected_egress_profiles.includes(id)
        ) &&
        this.selected_egress_profiles.length > 0
      ) {
        this.selected_egress_profiles = this.selected_egress_profiles.filter(
          (id) => !egress_profiles_ids.includes(id)
        );
      } else {
        let egr_pro_ids = egress_profiles_ids.filter(
          (id) => !this.selected_egress_profiles.includes(id)
        );
        this.selected_egress_profiles =
          this.selected_egress_profiles.concat(egr_pro_ids);
      }
    },
    changeSelectedEgressProfile(id) {
      this.all_items_fetched = false;
      const index = this.selected_egress_profiles.findIndex((x) => x == id);
      if (index != -1) this.selected_egress_profiles.splice(index, 1);
      else this.selected_egress_profiles.push(id);
    },
    toggleSelectAllPage(pageEgressProfileIds) {
      this.all_items_fetched = false;
      const allSelected = pageEgressProfileIds.every((id) =>
        this.selected_egress_profiles.includes(id)
      );
      if (allSelected) {
        this.selected_egress_profiles = this.selected_egress_profiles.filter(
          (id) => !pageEgressProfileIds.includes(id)
        );
      } else {
        const newIds = pageEgressProfileIds.filter(
          (id) => !this.selected_egress_profiles.includes(id)
        );
        this.selected_egress_profiles =
          this.selected_egress_profiles.concat(newIds);
      }
    },
    onTotalItems(count) {
      this.total_careers = count;
    },
    async selectAllItems() {
      try {
        const params = [];
        if (this.profile_type_id)
          params.push(`egress_profile_type__id=${this.profile_type_id}`);
        if (this.faculty_ids.length > 0)
          params.push(`faculty__id__in=${this.faculty_ids.join(",")}`);
        const response = await this.$restful.Get(
          `/mesh/alt-career/egress-profile-ids/?${params.join("&")}`
        );
        this.selected_egress_profiles = response.egress_profile_ids;
        this.all_items_fetched = true;
      } catch (e) {
        // mantener selección actual si falla
      }
    },
    clearFilters() {
      this.profile_type_id = null;
      this.faculty_ids = [];
    },
    clearSelection() {
      this.selected_egress_profiles = [];
      this.all_items_fetched = false;
    },
    redirectToCareerReport() {
      const url = this.$router.resolve({
        name: "CareerReportView",
        params: {},
      }).href;
      window.open(url, "_blank");
    },
    getModalityName(modality_id) {
      const modality = this.modalities_egress_profiles.find(
        (x) => x.id == modality_id
      );
      return modality ? modality.name : "";
    },
    slotCreatedCareer(/*career*/) {
      this.$bvModal.hide("new-career-modal");
      this.table_refresh_key++;
    },
    askForDeleteCareer(career_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirm"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_CAREER, career_id).then(() => {
            toast(
              this.$t("careerOrPrograms.careerListView.entityDeleted", {
                entity: this.$getVisibleNames("mesh.career", false, "Programa"),
              })
            );
            this.table_refresh_key++;
          });
        }
      });
    },
    toggleCycles() {
      return (this.is_hidden = !this.is_hidden);
    },
    slotCreateEgressProfile(career) {
      this.career_id_for_egress_modal = career.id;
      this.$bvModal.show("modal-create-egress-profile");
    },
    slotCreatedEgreesProfile(egress_profile) {
      this.$store.commit(names.MUTATE_DELETE_CAREER, egress_profile.career);
      this.$bvModal.hide("modal-create-egress-profile");
      this.$store.dispatch(names.FETCH_CAREER, egress_profile.career);
      this.table_refresh_key++;
    },
    fullyVisibleProfessorEgressProfiles() {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          this.fully_visible_professor_egress_profiles = response;
        });
    },
  },
  created() {
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.fullyVisibleProfessorEgressProfiles();
    }
    this.$store.dispatch(names.FETCH_FACULTIES);
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
    this.$store.dispatch(names.FETCH_PROFILE_TYPES);
    this.$store.dispatch(names.FETCH_COMPETENCE_TYPES);
    this.$store.dispatch(names.FETCH_MODALITIES_EGRESS_PROFILE);
    this.$store.dispatch(names.FETCH_COMPETENCES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }

      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.bulk-selection-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-radius: 6px;
  background: #e8f4fd;
  border: 1px solid #bee3f8;
  font-size: 0.875rem;
  color: #2d3748;
}
/* Barra de filtros: card suave con controles del mismo alto (estándar --kl-input-*) */
.career-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  padding: 0.75rem 1rem;
  background: var(--kl-surface-muted);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-radius-lg);
}
.career-filter {
  display: flex;
  flex-direction: column;
  flex: 0 1 240px;
  min-width: 200px;
}
.career-filter-wide {
  flex: 1 1 320px;
  max-width: 560px;
}
.career-filter-label {
  margin-bottom: 0.25rem;
  font-size: var(--kl-fs-caption);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text-muted);
  text-align: left;
}
.career-filter-input {
  height: var(--kl-input-height);
  font-size: var(--kl-input-fs);
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius);
  background-color: var(--kl-surface);
}
.career-filter-input:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: 0 0 0 0.15rem var(--kl-color-accent-soft);
}
.career-filter-multiselect >>> .vs__dropdown-toggle {
  min-height: var(--kl-input-height);
  padding: 0 0 2px;
  font-size: var(--kl-input-fs);
  background: var(--kl-surface);
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius);
}
.career-filter-multiselect.vs--open >>> .vs__dropdown-toggle {
  border-color: var(--kl-input-border-focus);
  box-shadow: 0 0 0 0.15rem var(--kl-color-accent-soft);
}
.career-filter-multiselect >>> .vs__search::placeholder {
  color: var(--kl-text-muted);
}
/* Facultades elegidas con el formato de chip suave del estándar */
.career-filter-multiselect >>> .vs__selected {
  margin: 4px 2px 0;
  padding: var(--kl-chip-padding);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  color: var(--kl-chip-text);
  background: var(--kl-chip-bg);
  border: 1px solid var(--kl-chip-border);
  border-radius: var(--kl-chip-radius);
}
.career-filter-multiselect >>> .vs__deselect {
  fill: var(--kl-chip-text);
}
.career-filter-multiselect >>> .vs__dropdown-menu {
  font-size: var(--kl-input-fs);
  border-radius: 0 0 var(--kl-input-radius) var(--kl-input-radius);
}
.career-filters-clear {
  height: var(--kl-input-height);
  color: var(--kl-text-muted);
}
.career-filters-clear:hover {
  color: var(--kl-color-danger);
  text-decoration: none;
}
@media (max-width: 576px) {
  .career-filter,
  .career-filter-wide {
    flex: 1 1 100%;
    max-width: none;
  }
}
.toggle-types {
  display: flex;
  float: right;
  margin-right: 1em;
  background: rgb(230, 230, 230);
  padding: 0.3em 4.8em;
  border-radius: 3px;
}
.small-table {
  min-height: 475px;
}
.dropdown-header {
  color: #212529;
  font-weight: 400;
  font-size: 1rem;
}
.hidden {
  display: none;
  padding-bottom: 10px;
}
.career-redirect-button-text {
  margin-left: 4px;
}
.career-redirect-button,
.career-m2-redirect-button {
  width: 38px;
  height: 38px;
  overflow: hidden;
  white-space: nowrap;
  transition: 0.6s ease-in-out;
  margin: 2px;
  padding: 0 5px;
  border-radius: 8px;
  color: #6c757d;
}
.career-redirect-button:hover,
.career-m2-redirect-button:hover {
  width: 184px;
  padding-right: 100px !important;
  font-size: 16px !important;
  transition: 0.4s ease-in;
  color: #fff;
}
.career-redirect-button .navigation-icon,
.career-m2-redirect-button .navigation-icon {
  margin: 0 5px;
}

.edit {
  margin-top: 0.3rem;
}
.toggle-height {
  height: 100px !important;
}
.cycles {
  transition: 0.3s ease-in;
  width: 184px;
  text-align: left;
  border-radius: 6px;
  padding: 0 1px;
}
.cycles:hover {
  background-color: rgb(221, 221, 221);
  color: #3f3f3f;
  width: 184px;
  transition: 0.2s ease-in;
}
.add-career {
  margin-left: 76% !important;
  margin-bottom: -8%;
  padding-top: 1.3%;
}
.search-career {
  max-width: 60%;
  margin: 0 15%;
}
/* .table-responsive >>> .generic-table {
  overflow: inherit;
} */
.check-type {
  background: #007bff !important;
  margin-inline: 0.7em;
  height: 1.1em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.icon-check {
  color: white;
  transform: translate(-70%, -43%);
  transition: 0.2s;
}
.icon-check-active {
  transform: translate(15%, -43%) !important;
}
@media (min-width: 1378px) {
  .add-career {
    margin-left: 78% !important;
  }
}
@media print {
  .egress-profile-scroll {
    max-height: 100% !important;
  }
}
@media (max-width: 800px) {
  .search-career {
    max-width: 50%;
    margin: 0;
  }
  .add-career {
    margin-left: 70% !important;
  }
}
</style>